import {ExternalLinksLegacyStrategy} from "./external-links-legacy.strategy";
import {MarketingParams} from "../../../../common/interfaces/marketing-params.interface";
import {IExternalLinksHandlersFactory} from "../handlers-factory/external-links-handlers-factory.interface";
import {IOpenMyAccountOptions} from "../handlers/my-account/my-account.external-link-handler.interface";
import {IOpenOmgOptions, OpenLinkParams} from "../external-links.service.interface";
import {IOpenRegistrationOptions} from "../handlers/registration/registration.external-link-handler.interface";
import {OpenCashierOptions} from "../../../../common/interfaces/cashier.service.interface";
import {GNWP_SOURCES} from "../../../../sdk/src/components/external_links/external_links_consts";
import {PRIORITY_LEVEL} from "../../../../sdk/src/services/overlay_manager/overlay_manager_levels";
import {ExternalLinksZIndexes} from "../external-links-z-indexes";

export class ExternalLinksModernStrategy extends ExternalLinksLegacyStrategy {

    private get _handlers(): IExternalLinksHandlersFactory {
        return this.services.regulation.current.externalLinks;
    }


    async openMyAccount(options?: IOpenMyAccountOptions, marketingParams?: MarketingParams): Promise<void> {
        await this._handlers.myAccount.openMyAccount(options);
    }

    async openCashier(options?: OpenCashierOptions): Promise<void> {
        await this._handlers.cashier.openCashier(options);
    }

    async openMembership(options?: IOpenRegistrationOptions): Promise<void> {
        await this._handlers.registration.openRegistration(options);
    }

    openLink(params: OpenLinkParams, marketingParams?: MarketingParams, useCallbackURL: boolean = false): Promise<any> {
        if(params.source === GNWP_SOURCES.MEMBERSHIP) {
            return this.openMembership({
                ...params?.options,
                marketingParams: marketingParams
            });
        } else if(params.source === GNWP_SOURCES.CASHIER) {
            return this.openCashier(params.options);
        } else if(params.source === GNWP_SOURCES.MY_ACCOUNT) {
            return this.openMyAccount(params.options);
        } else if(params.source === GNWP_SOURCES.OMG) {
            return this.openOMG({
                openedWithinGame: params.options.openedWithinGame,
                messages: params.options.Messages,
                zIndex: params.priorityLevel === PRIORITY_LEVEL.OMG ? ExternalLinksZIndexes.Omg : ExternalLinksZIndexes.OmgBehindTheGame,
            })
        }
        return super.openLink(params, marketingParams, useCallbackURL);
    }

    openOMG(options: IOpenOmgOptions): Promise<void> {
        return this._handlers.omg.openOmg(options);
    }

}